import { useMemo } from "react";


export interface FilterEntry {
  label: string;
  active: boolean;
  displayValue: string;
  onRemove?: () => void;
}

export interface ActiveFilterResult {
  activeFilterCount: number;
  activeFilterNames: { label: string; onRemove?: () => void }[];
}

export function useActiveFilters(entries: FilterEntry[]): ActiveFilterResult {
  return useMemo(() => {
    const active = (entries ?? []).filter(e => e.active);
    return {
      activeFilterCount: active.length,
      activeFilterNames: active.map(e => ({
        label: `${e.label}: ${e.displayValue}`,
        onRemove: e.onRemove
      })),
    };
  }, [entries]);
}
